import type {
  CreateCustomizationProjectWithTraceResult,
  CustomizationTraceCreate,
} from "../types";

/** 创建本地临时草稿项目的首条追溯记录。 */
export function createCustomizationProjectWithTrace(
  payload: CustomizationTraceCreate,
): Promise<CreateCustomizationProjectWithTraceResult> {
  return import("../repo/customizationRepo").then(
    ({ createCustomizationProjectWithTrace: createCustomizationProjectWithTraceRequest }) =>
      createCustomizationProjectWithTraceRequest(payload),
  );
}
